<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
      ref="editForm"
      :disabled="true"
    >
      <el-row>
        <el-form-item label="客户名称" prop="customerName">
          <el-input
            size="small"
            v-model="editForm.customerName"
            auto-complete="off"
            placeholder="客户名称"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="业务员" prop="outInterSalesman">
          <el-input
            size="small"
            v-model="editForm.outInterSalesman"
            auto-complete="off"
            placeholder="业务员"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="业务员助手">
          <el-input
            size="small"
            v-model="editForm.outInterSalesmanCommission"
            auto-complete="off"
            placeholder="业务员助手"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="出点（%）" prop="outPercentage">
          <el-input-number
            :min="0"
            :max="100"
            size="small"
            :controls="false"
            v-model="editForm.outPercentage"
            placeholder="出点（%）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="拟售价（%）" prop="preSale">
          <el-input-number
            :min="0"
            :max="100"
            size="small"
            :controls="false"
            v-model="editForm.preSale"
            placeholder="拟售价（%）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="出库状态" prop="outStatus">
          <el-input
            size="small"
            v-model="editForm.outStatus"
            auto-complete="off"
            placeholder="出库状态"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报价员" prop="outBidder">
          <el-input
            size="small"
            v-model="editForm.outBidder"
            auto-complete="off"
            placeholder="请输入报价员"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="应收（万）" prop="outReceivable">
          <el-input-number
            :min="0"
            :controls="false"
            size="small"
            v-model="editForm.outReceivable"
            placeholder="应收（万）"
          ></el-input-number>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="应付（万）" prop="outPayable">
          <el-input-number
            :min="0"
            :max="100"
            :controls="false"
            size="small"
            v-model="editForm.outPayable"
            placeholder="应付（万）"
          ></el-input-number>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
    handlePayment() {
      this.handleClose();
      this.$emit("confirm");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/ticket/ticket-estimate/add-edit/detail.vue